export interface CollectionTag {
  value: string;
  amount?: number;
  type?: 'tag' | 'extraTag';
}
